import { Divider, Stack, StackProps, styled } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { ReactElement, ReactNode } from 'react';

const Header = styled(PoolTypography)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export interface SettingsSectionProps extends StackProps {
    sectionTitle: ReactNode;
}

export const SettingsSection = (props: SettingsSectionProps): ReactElement => {
    const { sectionTitle, children, ...stackProps } = props;
    return (
        <Stack divider={<Divider />} gap={3} {...stackProps}>
            <Header styleType="sectionTitleNew">{sectionTitle}</Header>
            {children}
        </Stack>
    );
};
